<template>
  <section :class="['section', 'child-view', 'section--expertise', 'section--expertise-child']">
    <div class="wrapper" :class="{ 'with-modal': isModalVisible}">
      <div class="content">
        <div class="heading">
          <div class="back-btn">
            <router-link
              :to="`/expertise`">
            </router-link>
            <span>back</span>
          </div>
        </div>
        <div class="expertise-holder">
          <ul class="parts-number">
            <li class="number-1">
              <span class="number">/1</span>
              <span class="text">UX Design</span>
              <ul class="list-tools">
                <li>
                  <img src="../assets/images/programs_icons/figma.svg" alt="figma">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/adobexd.svg" alt="adobe xd">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/sketch.svg" alt="sketch">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/miro.svg" alt="miro">
                </li>
              </ul>
            </li>
            <li class="number-2">
              <span class="number">/2</span>
              <span class="text">UI Design</span>
              <ul class="list-tools">
                <li>
                  <img src="../assets/images/programs_icons/figma.svg" alt="figma">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/adobexd.svg" alt="adobe xd">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/sketch.svg" alt="sketch">
                </li>
              </ul>
            </li>
          </ul>
          <div class="expertise-container">
            <span class="circle-title">Design<br /> Review</span>
            <div class="circle-holder">
              <ul class="circle-block">
                <li class="circle-button size-1">
                  <div class="text-holder"
                    @click="openModal('design-review')">
                    <span class="text">Design<br /> Review</span>
                  </div>
                </li>
                <li class="circle-button size-1">
                  <div class="text-holder"
                    @click="openModal('design-audit')">
                    <span class="text">Design<br /> Audit</span>
                  </div>
                </li>
                <li class="circle-button size-3 requirements">
                  <div class="text-holder"
                    @click="openModal('requirements-review')">
                    <span class="text">Requirements<br /> review</span>
                  </div>
                </li>
                <li class="circle-button size-1">
                  <div class="text-holder"
                    @click="openModal('design-check')">
                    <span class="text">Design<br /> Check</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div><!--end content-->
    </div>
    <window-modal v-show="isModalVisible" v-model="modalData[activeItem]" @close="closeModal"></window-modal>
  </section>
</template>

<script>
import Footer from '@/components/UI/Footer';
import { mapActions } from 'vuex';
import WindowModal from '@/components/modals/WindowModal.vue';

export default {
  mounted() {
    document.addEventListener('keydown', this.onKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown);
  },
  data() {
    return {
      isModalVisible: false,
      activeItem: 'design-review',
      modalData: {
        'design-review': {
          title: 'Design Review',
          content: 'A "Design Review" is an evaluation of the user experience of a digital product or website, typically conducted by experts or usability specialists. It involves assessing the design, interface, and usability of the product to identify areas of improvement, enhance user satisfaction, and ensure that it aligns with user-centered design principles.',
          linkUrl: 'https://www.figma.com/proto/Vi0Ug4vuU1O7xmT5H2zAKh/UX-Methods-MD-Team-Library?node-id=4653-4648&viewport=-9614%2C-10%2C0.14&t=gHZFkB93xJuKAIr2-1&scaling=scale-down-width&content-scaling=fixed&starting-point-node-id=4653%3A4648&page-id=0%3A1',
          sizeClass: 'size-1',
        },
        'design-audit': {
          title: 'Design Audit',
          content: 'The main value of Design Audit is to conduct a comprehensive evaluation of a design, assessing its effectiveness, adherence to standards, alignment with brand and strategy, identifying strengths and weaknesses, and identifying areas for improvement. It provides an objective assessment of the design\'s quality, identifies potential areas of concern, and offers actionable recommendations for further development.',
          linkUrl: 'https://www.figma.com/proto/Vi0Ug4vuU1O7xmT5H2zAKh/UX-Methods-MD-Team-Library?node-id=4653-4648&viewport=-9614%2C-10%2C0.14&t=gHZFkB93xJuKAIr2-1&scaling=scale-down-width&content-scaling=fixed&starting-point-node-id=4653%3A4648&page-id=0%3A1',
          sizeClass: 'size-1',
        },
        'requirements-review': {
          title: 'Requirements Review',
          content: 'A "Requirements Review" is a systematic examination of project or product requirements to ensure clarity, completeness, and consistency. It involves analyzing the documented requirements to verify that they accurately capture the desired functionalities and outcomes, serving as a crucial quality control step in the early stages of project development.',
          linkUrl: 'https://google.com',
          sizeClass: 'size-3',
        },
        'design-check': {
          title: 'Design Check',
          content: 'Involves assessing the design\'s feasibility, compliance with specifications and requirements, potential issues, and overall quality to ensure it aligns with the project\'s goals and objectives. This step helps identify and rectify any design flaws or discrepancies before proceeding to the implementation phase, ultimately saving time and resources in the long run.',
          linkUrl: 'https://google.com',
          sizeClass: 'size-1',
        },
      },
    };
  },
  methods: {
    ...mapActions({ fetchExpertisePageContent: '/expertise/expertise:fetch' }),
    openModal(activeItemName) {
      this.activeItem = activeItemName;
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onKeydown(event) {
      if (event.key === 'Escape') {
        this.closeModal();
      }
    },
  },
  components: {
    Footer,
    WindowModal,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ExpertiseDesignReview.vue